import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import Snackbar from 'material-ui/Snackbar'
import { FormattedMessage } from 'react-intl'
import ProfilePic from '../../components/ProfilePic'
import SettingsForm from '../../components/SettingsForm'
import Upload from '../../components/Upload'

class GuestSettings extends Component {
  state = {
    snackbarOpen: false
  }

  componentDidMount = () => {
    console.log('componentDidMount')
    console.log(this.props)
  }

  componentWillReceiveProps = (props) => {
    if (props.emailChange) {
      this.setState({snackbarOpen: true})
      this.setState({snackbarEmailChange: true})
      props.closeSnackbar()
    }
  }

  handleRequestClose = () => this.setState({snackbarOpen: false})
  handleRequestOpen = () => this.setState({snackbarOpen: true})

  render() {
    return (
      <div className='h-100 w-100 flex items-center pt3 pr6 justify-center'>
        <Paper
          className={`pt3 pb3 ${(this.props.showWebcam || this.props.showUploadOtion) ? 'pl3 pr3' : 'pl5 pr5'}`}
          rounded={false}
          style={{
            width: 544,
            backgroundColor: '#FAFAFA',
            height: (this.props.showWebcam || this.props.showUploadOtion) ? 590 : '100%'
          }}>
          {(this.props.showWebcam) ? (
            <Upload
              returnUserIfUserExists={this.props.returnUserIfUserExists}
              userid={this.props.userid}
              handleRequestOpen={this.handleRequestOpen}
              webcam takePicture={this.props.takePicture}/>
          ) : (this.props.showUploadOtion) ? (
            <Upload
              returnUserIfUserExists={this.props.returnUserIfUserExists}
              userid={this.props.userid}
              handleRequestOpen={this.handleRequestOpen}
              takePicture={this.props.uploadPicture}/>
          ) : (
            <div className='h-100 w-100'>
              <ProfilePic
                height='20%'
                userid={this.props.userid}
                uploadPicture={this.props.uploadPicture}
                takePicture={this.props.takePicture}/>
              <div style={{height: '80%'}}>
                <SettingsForm {...this.props} />
              </div>
            </div>
          )}
        </Paper>
        {false && <Snackbar
          style={{left: 200, bottom: 30}}
          open={this.state.snackbarOpen}
          message={this.state.snackbarEmailChange ? (<FormattedMessage id='settings.updateEmail'/>) : (
            <FormattedMessage id='settings.picMessage'/>)}
          action={<FormattedMessage id='seminarActions.dismiss'/>}
          onActionTouchTap={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />}
      </div>
    )
  }
}

export default GuestSettings



// WEBPACK FOOTER //
// src/routes/Settings/GuestSettings.js